export async function FileUploader( 
    docFile
     ) {
    const formData = new FormData();
    formData.append('file', docFile);
    console.log(formData);

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/media', {
                method: 'POST',
                headers: {
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: formData,
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}